document.addEventListener('DOMContentLoaded', () => {
    let filteredProducts = document.getElementById("collection-products");
    let filteredItemsCountText = document.querySelector(".td-custom-collection__filtered-products-count");

    if (filteredProducts && filteredItemsCountText) {
        filteredItemsCountText.innerText = filteredProducts.getAttribute("data-filtered-products");
    }

    let eS = document.querySelector(".empty-slot");

    if (eS) {
        if (window.innerWidth > 768 && Number(eS.getAttribute("data-index")) % 4 == 0) {
            eS.classList.add("td-full-width");
        } else if (window.innerWidth <= 768 && Number(eS.getAttribute("data-index")) % 2 == 0) {
            eS.classList.add("td-full-width");
        }
    }

    let sortLabel = document.querySelector('.td-custom-collection-sort__label');
    let sortSelect = document.querySelector('#sortBy');
    let sortDesktop = document.querySelector('#sortBy-desktop');

    if (sortLabel && sortSelect && sortDesktop) {
        sortLabel.addEventListener('mousedown', function (event) {
            let evt = event;
            setTimeout(function () {
                sortSelect.dispatchEvent(evt)
            })
        });

        sortDesktop.addEventListener('change', function () {
            sortSelect.value = this.value;
            sortSelect.dispatchEvent(new Event('change'));
        })
    }
})